import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8.216 35.677a.877.877 0 0 0-.877-.877h-.831c-.969 0-1.754-.785-1.754-1.795.031-1.284.07-2.106.11-2.424.31-2.43 1.067-4.71 2.185-6.76l2.304 1.33c1.013.584 1.89-.935.877-1.52l-2.272-1.31a19.382 19.382 0 0 1 5.822-5.639l1.306 2.264c.585 1.012 2.104.135 1.52-.877l-1.299-2.248a19.212 19.212 0 0 1 7.817-2.047v2.607a.877.877 0 1 0 1.753 0v-2.607c2.794.125 5.443.848 7.816 2.047L31.4 18.062c-.584 1.013.935 1.89 1.52.877l1.302-2.257a19.38 19.38 0 0 1 5.822 5.638l-2.136 1.233c-1.012.585-.135 2.104.877 1.519l2.168-1.251a19.161 19.161 0 0 1 2.18 6.722c.042.325.082 1.159.114 2.46.023.969-.742 1.773-1.754 1.797a.877.877 0 0 0-.877.877c0 .485.393.877.963.876a3.508 3.508 0 0 0 3.42-3.592c-.033-1.368-.073-2.235-.126-2.643C43.522 19.89 34.609 12 24 12 13.376 12 4.455 19.913 3.124 30.36c-.051.4-.09 1.253-.123 2.602a5.678 5.678 0 0 0-.001.085 3.508 3.508 0 0 0 3.508 3.507h.83a.877.877 0 0 0 .878-.877Zm17.043-1.372c-.684.684-1.803.678-2.5-.019-.506-.507-2.253-3.091-5.14-7.62 4.53 2.886 7.114 4.633 7.621 5.14.697.697.703 1.815.019 2.499Zm-11.209-10c4.276 6.798 6.705 10.457 7.47 11.221 1.378 1.38 3.608 1.39 4.98.02 1.37-1.372 1.36-3.601-.02-4.98-.764-.765-4.423-3.194-11.22-7.47-.79-.496-1.706.42-1.21 1.21Z",
      clipRule: "evenodd"
    }
  )
);
var SvgDialLowOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var DialLowOutlined_default = SvgDialLowOutlined;

export { DialLowOutlined_default as default };
